import { HANA_CLIENT_INFO } from '@hana/work-calendar';

// Mint-LaborContract · tab Phát hành (code board khối tabIss: EMP, gateOf, inFields, pv). Dữ liệu mẫu, chỉ đọc.
// Không lương / CCCD: lương chính luôn che (trạng thái noperm của board); CCCD / thường trú in lúc điền.

export type EmpKey = 'LanVT' | 'HanVN' | 'NhiTHT' | 'THANHTTK' | 'AnNV';
/** [user, tên, ghế, phòng, học vấn, số HĐ XĐTH đã ký, mẫu gợi ý, chức danh] */
export const ISSUE_EMPS: readonly (readonly [EmpKey, string, string, string, string, number, string, string])[] = [
  ['LanVT', 'Võ Thị Lan (mẫu)', 'CSD-CSO · L02', 'CSD', 'Đại học', 0, 'HDTV-02M', 'Nhân viên DVKH'],
  ['HanVN', 'Vũ Ngọc Hân (mẫu)', 'CSD-CSO · L02', 'CSD', 'Trung cấp', 0, 'HDTV-02M', 'Nhân viên DVKH'],
  ['NhiTHT', 'Trần Hoàng Thảo Nhi', 'CSD-BKG · L03', 'CSD', 'đã khai', 1, 'HDLD-36M', 'Nhân viên Đặt chỗ'],
  ['THANHTTK', 'Trương Thị Kim Thành', 'TRD-DSP · L03', 'TRD', 'đã khai', 2, 'HDLD-KXD', 'Nhân viên Điều độ'],
  ['AnNV', 'Nguyễn Văn An', 'OPS-FLD · L03', 'OPS', 'đã khai', 1, 'HDLD-36M', 'Nhân viên hiện trường'],
];
export type IssueEmp = (typeof ISSUE_EMPS)[number];

export const ISSUE_TEMPLATES: readonly (readonly [string, string])[] = [
  ['HDTV-02M', 'HĐ thử việc 2 tháng'],
  ['HDDT-06M', 'HĐ đào tạo nghề 6 tháng'],
  ['HDLD-12M', 'HĐLĐ xác định thời hạn 12 tháng'],
  ['HDLD-36M', 'HĐLĐ xác định thời hạn 36 tháng'],
  ['HDLD-KXD', 'HĐLĐ không xác định thời hạn'],
];
const MONTHS: Record<string, number> = { 'HDTV-02M': 2, 'HDDT-06M': 6, 'HDLD-12M': 12, 'HDLD-36M': 36 };

export interface Gate { block: string; warns: string[] }
export function gateOf(code: string, e: IssueEmp): Gate {
  const fixed = /HDLD-(12|36)M/.test(code);
  const warns: string[] = [];
  let block = '';
  if (code === 'HDTV-02M' && !['Sau đại học', 'Đại học', 'Cao đẳng', 'đã khai'].includes(e[4])) block = `Điều 25: trình độ ${e[4]} chỉ thử việc tối đa 30 ngày — cần mẫu 30 ngày (chưa có)`;
  if (code === 'HDTV-02M' && e[5] > 0) block = 'Đã là nhân viên chính thức — không ký thử việc';
  if (fixed && e[5] >= 2) block = `Điều 20 khoản 2: đã ký ${e[5]} HĐ xác định thời hạn → lần này bắt buộc không xác định thời hạn`;
  if (fixed && e[5] === 1) warns.push('Lần 2 xác định thời hạn — lần sau bắt buộc không xác định thời hạn');
  if (code === 'HDDT-06M') warns.push('Chỉ dùng khi có chương trình đào tạo nghề kèm theo');
  warns.push('Mẫu Draft (chưa duyệt) → bản phát hành đánh dấu NHÁP');
  return { block, warns };
}

const MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DIM = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
/** Cộng n tháng rồi lùi 1 ngày: "03/Nov/2026" + 2 → "02/Jan/2027". */
export function addMonths(s: string, n: number): string {
  const m = /^(\d{2})\/(\w{3})\/(\d{4})$/.exec(s);
  if (!m) return '—';
  let mi = MON.indexOf(m[2] ?? '') + n;
  let y = Number(m[3]);
  y += Math.floor(mi / 12);
  mi = ((mi % 12) + 12) % 12;
  let d = Number(m[1]) - 1;
  if (d < 1) {
    mi -= 1;
    if (mi < 0) { mi = 11; y -= 1; }
    d = DIM[mi] ?? 30;
  }
  return `${String(d).padStart(2, '0')}/${MON[mi]}/${y}`;
}

export const defaultFrom = (u: EmpKey) => (u === 'LanVT' || u === 'HanVN' ? '03/Nov/2026' : u === 'THANHTTK' ? '01/Dec/2026' : '16/Nov/2026');

export interface IssueInput { sign?: string; from?: string }
export interface IssueView {
  gate: Gate; isKxd: boolean; months: number; from: string; to: string; kyLan: number; soHD: string; missAddr: boolean; canIssue: boolean;
  chips: { k: string; tone: 'mute' | 'warn' | 'err' }[];
}
export function issueView(e: IssueEmp, tpl: string, inp: IssueInput): IssueView {
  const gate = gateOf(tpl, e);
  const isKxd = tpl === 'HDLD-KXD';
  const months = MONTHS[tpl] ?? 0;
  const from = inp.from ?? defaultFrom(e[0]);
  const idx = ISSUE_EMPS.findIndex((x) => x[0] === e[0]);
  const missAddr = e[0] === 'LanVT' || e[0] === 'HanVN';
  return {
    gate, isKxd, months, from,
    to: isKxd ? 'Không xác định' : addMonths(from, months),
    kyLan: /HDLD-(12|36)M/.test(tpl) ? e[5] + 1 : 1,
    soHD: `HN-${tpl.replace('-02M', '').replace('-06M', '')}-2026-0${31 + idx}`,
    missAddr,
    canIssue: !gate.block && !missAddr,
    chips: [
      { k: e[2], tone: 'mute' },
      { k: `Học vấn: ${e[4]}`, tone: e[4] === 'Trung cấp' ? 'warn' : 'mute' },
      { k: `Đã ký XĐTH ${e[5]} lần`, tone: e[5] >= 2 ? 'err' : 'mute' },
    ],
  };
}

/** Giờ làm việc in vào HĐ — lấy từ cột lịch tblClientInfo, không viết cứng. */
export function workHoursText(): string {
  const c = HANA_CLIENT_INFO;
  return `T2–T7 · ${c.WorkMorningStart}–${c.WorkMorningEnd}, ${c.WorkAfternoonStart}–${c.WorkAfternoonEnd} · T7 đến ${c.WorkSatEnd}`;
}
export const annualLeaveDays = () => HANA_CLIENT_INFO.AnnualLeaveDays;
